import React from 'react';

const IndexMenu = ({ indexState, onIndexChange }) => {
    return (
        <div className="filters__sort" style={{ display: 'block' }}>
            <label
                className="toggleButton -link"
                onClick={() => {
                    onIndexChange('all');
                }}
            >
                <span className={`toggleButton__label ${indexState === 'all' ? '-bold' : ''}`}>ALL</span>
            </label>
            <span className="filters__spacer">&nbsp;|&nbsp;</span>

            <label
                className="toggleButton -link"
                onClick={() => {
                    onIndexChange('events');
                }}
            >
                <span className={`toggleButton__label ${indexState === 'events' ? '-bold' : ''}`}>EVENTS</span>
            </label>
            <span className="filters__spacer">&nbsp;|&nbsp;</span>

            <label
                className="toggleButton -link"
                onClick={() => {
                    onIndexChange('insights');
                }}
            >
                <span className={`toggleButton__label ${indexState === 'insights' ? '-bold' : ''}`}>INSIGHTS</span>
            </label>
            <span className="filters__spacer">&nbsp;|&nbsp;</span>

            <label
                className="toggleButton -link"
                onClick={() => {
                    onIndexChange('news');
                }}
            >
                <span className={`toggleButton__label ${indexState === 'news' ? '-bold' : ''}`}>NEWS</span>
            </label>
        </div>
    );
};

export default IndexMenu;
